module.exports = __webpack_public_path__ + "static/media/DailySpecials.bca568d9.pdf";